import {XCircleIcon} from "@heroicons/react/24/outline"
import {useEffect} from "react"
import {AccountRecordingItemStatusBadge} from "../../components/account/recording/AccountRecordingItemStatusBadge"
import {useAccountRecording} from "../../hooks/useAccountRecording.tsx";
import CircleLoader from "../../components/loaders/CircleLoader.tsx";
import AccountLayout from "../../components/layouts/AccountLayout.tsx";

export const AccountRecordingManagementPage = () => {
    // const [recordings, setRecordings] = useState<IRecording>();
    const {recordings, getAll} = useAccountRecording();
    // const {user} = useAuth();
    const getUsedTimeInProcent = (totalTime: number, freeTime: number): number => {
        return (((totalTime - freeTime) / totalTime) * 100);
    };
    const getHourFromSeconds = (seconds: number) => {
        return Math.floor(seconds / 60 / 60);
    }
    const getMinutesFromSeconds = (seconds: number) => {
        const second = seconds % 60;
        const minute = Math.floor(seconds / 60);
        return `${String(minute).padStart(2, "0")}:${String(second).padStart(2, "0")}`;
    }

    useEffect(() => {
        // console.log('user' + user);
        // (async () => {
        //     const response = await api.getRecordings();
        //     setRecordings(response.data);
        // })();
        //
        // if (user)
        //     (async () => {
        //         const response = await api.getRecordings();
        //         setRecordings(response.data);
        //     })();
        console.log("wukonuje ue w page");
        (async () => {
            await getAll();
        })();
    }, [getAll]);

    return (
        <AccountLayout>
            {recordings == "loading" && <CircleLoader/>}
            {recordings != null && recordings !== "loading" &&
                <div
                    className="bg-neutral-900 max-w-3xl rounded-3xl  py-3 mt-2 animate-opacityEaseIn overflow-hidden">
                    <ul className="overflow-y-scroll max-h-[calc(100vh-350px)]">
                        {recordings && !recordings.recordings.length &&
                            <p className="text-center text-base/7 my-2 text-neutral-400 mb-4">Brak nagrań</p>
                        }
                        {recordings && recordings.recordings.map(x =>
                            <li key={x.id}
                                className="border-b border-neutral-600 py-4 flex justify-between items-center gap-x-4 px-6">
                                <div className="text-sm space-y-1.5">
                                    <div className="min-w-0">
                                        <div className="flex flex-col-reverse md:flex-row items-start gap-x-3">
                                            <p className="text-sm/6 font-semibold text-gray-50">{x.program != '' ? x.program : "Brak tytułu"}</p>
                                            <AccountRecordingItemStatusBadge started={x.started} ended={x.ended}/>
                                        </div>
                                        <div className="mt-1 flex items-center gap-x-2 text-xs/5 text-neutral-400">
                                            <p>{x.channelName}</p>
                                            <svg viewBox="0 0 2 2" className="h-0.5 w-0.5 fill-current">
                                                <circle r={1} cx={1} cy={1}/>
                                            </svg>
                                            <p className="whitespace-nowrap">
                                                <time
                                                    dateTime="2023-03-17T00:00Z">{new Date(x.startTimestamp * 1000).toLocaleString()}</time>
                                            </p>
                                            <svg viewBox="0 0 2 2" className="h-0.5 w-0.5 fill-current">
                                                <circle r={1} cx={1} cy={1}/>
                                            </svg>
                                            <p>
                                                {getMinutesFromSeconds(x.length)} min
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <button className="inline-block rounded text-red-500"
                                            onClick={() => confirm("Czy na pewno chcesz usunac?")}><XCircleIcon
                                        className="w-8 h-8"/></button>
                                </div>
                            </li>
                        )}
                    </ul>
                    <div className="px-4 py-2 pt-3 border-t border-sky-600">
                        <div
                            className={`w-full bg-gray-200 rounded-full h-1 mb-1 dark:bg-gray-700 flex overflow-hidden mt-2 `}>
                            <div
                                className={`h-1 ${getUsedTimeInProcent(recordings.maxRecordsLength, recordings.freeRecordsLength) > 80 ? "bg-red-500" : "bg-sky-500"}`}
                                style={{width: `${getUsedTimeInProcent(recordings.maxRecordsLength, recordings.freeRecordsLength)}%`}}/>
                        </div>
                        <p className="text-left text-sm font-light text-neutral-400">Zajęte
                            miejsce: {getHourFromSeconds(recordings.maxRecordsLength - recordings.freeRecordsLength)} z {getHourFromSeconds(recordings.maxRecordsLength)} godzin</p>
                    </div>
                </div>
            }
        </AccountLayout>
    )
}